import { priceToBells } from '~/utilities/bells';
import { formatPrice } from '~/utilities/products';

export const coerceNumber = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }

    if (typeof value === 'number') {
        return isFinite(value) ? value : undefined;
    }

    if (typeof value === 'string') {
        const parsed = parseFloat(value);
        return isFinite(parsed) ? parsed : undefined;
    }

    return undefined;
};

export const normalizeAddonForDisplay = (addOn) => {
    const bellsCost = addOn.bellsCost ?? priceToBells(addOn.price ?? 0);
    const priceDisplay = addOn.useBells
        ? `${bellsCost} Bells`
        : formatPrice(addOn.price ?? 0);
    return { ...addOn, bellsCost, priceDisplay };
};

export const normalizeCartItemsForDisplay = (items) => {
    if (!Array.isArray(items)) {
        return [];
    }
    return items.map((item) => ({
        ...item,
        addOns: Array.isArray(item.addOns)
            ? item.addOns.map(normalizeAddonForDisplay)
            : []
    }));
};

export const normalizeTotals = (totals) => {
    if (!totals || typeof totals !== 'object') {
        return {};
    }

    const normalized = {};

    if (totals.subtotal_cents !== undefined) {
        normalized.subtotal = coerceNumber(totals.subtotal_cents) / 100;
    }

    if (totals.tax_cents !== undefined) {
        normalized.tax = coerceNumber(totals.tax_cents) / 100;
    }

    if (totals.discount_cents !== undefined) {
        normalized.discount = coerceNumber(totals.discount_cents) / 100;
    }

    if (totals.shipping_cents !== undefined) {
        normalized.shipping = coerceNumber(totals.shipping_cents) / 100;
    }

    if (totals.total_cents !== undefined) {
        normalized.grandTotal = coerceNumber(totals.total_cents) / 100;
    }

    if (totals.currency !== undefined) {
        normalized.currency = totals.currency;
    }

    if (totals.giftCardBalance !== undefined) {
        normalized.giftCardBalance = coerceNumber(totals.giftCardBalance);
    }

    return normalized;
};

export function normalizeCart(raw) {
    if (!raw || typeof raw !== 'object') {
        return {
            id: '',
            cart_id: '',
            items: [],
            totals: {},
            createdAt: undefined,
            updatedAt: undefined
        };
    }

    const id = raw.cart_id || raw.id || '';
    const items = normalizeCartItemsForDisplay(
        Array.isArray(raw.items) ? raw.items : []
    );
    const totals = normalizeTotals(raw.totals);
    const discounts = Array.isArray(raw.discounts) ? raw.discounts : undefined;
    const customer = raw.customer;
    const cart_token = raw.cart_token || null;
    const items_hash = raw.items_hash || null;

    const normalized = {
        id,
        cart_id: id,
        cart_token,
        items,
        totals,
        createdAt: raw.createdAt || raw.created_at,
        updatedAt: raw.updatedAt || raw.updated_at
    };

    if (discounts !== undefined) {
        normalized.discounts = discounts;
    }

    if (customer !== undefined) {
        normalized.customer = customer;
    }

    if (items_hash !== null) {
        normalized.items_hash = items_hash;
    }

    return normalized;
}
